module.exports = __webpack_public_path__ + "static/media/zm.a9ff495d.svg";